import React from "react";
import { Redirect, withRouter, RouteComponentProps } from "react-router";
import { Row, Col } from "reactstrap";
import classNames from "classnames";
import { Icon } from "@cadmakers-ui/icons";
import iconStyles from "../../../../Common/Styles/Icons.module.scss";
import { AutocompleteItem, FeedbackAutocompleteItem } from "../../../Models/AutocompleteItem";
import styles from "../../../Styles/SearchBarContainer.module.scss";
import { appPaths } from "../../../../Common/Constants/appPaths";
import FeedbackCategoryBadge from "../../../../Feedback/Components/Common/FeedbackBadges/FeedbackCategoryBadge";
import FeedbackStateBadge from "../../../../Feedback/Components/Common/FeedbackBadges/FeedbackStateBadge";
import { feedbackService } from "../../../../Feedback/Services";
import FeedbackWorkflowStateBadge from "../../../../Feedback/Components/Common/FeedbackBadges/FeedbackWorkflowStateBadge";

type Props = {
  item: FeedbackAutocompleteItem;
  isRedirecting: boolean;
  isSelected: boolean;
  onClick?: (item: AutocompleteItem) => void;
  clearAutocompleteIfLoaded: () => void;
};

type State = {
  isRedirecting: boolean; // if this is true, this result will redirect to its feedback when it is rendered
};

class FeedbackAutocompleteResult extends React.Component<Props & RouteComponentProps, State> {
  constructor(props: Props & RouteComponentProps) {
    super(props);

    // only do the redirect if it is to a different page
    const isRedirecting = props.isRedirecting && this.getRedirectUrl() !== props.location.pathname;

    this.state = {
      isRedirecting
    };

    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    // check if onClick is defined
    if (this.props.onClick) {
      // do the onclick
      this.props.onClick(this.props.item);
    } else {
      // no click handler defined
      // set this to redirect immediately
      this.setState(prevState => {
        return {
          ...prevState,
          isRedirecting: true
        };
      });
    }
  }

  getRedirectUrl(): string {
    return feedbackService.getAutocompleteViewUrl(this.props.item);
  }

  render() {
    if (this.state.isRedirecting) {
      return <Redirect to={this.getRedirectUrl()} />;
    }
    const itemClasses = classNames(styles.autocompleteItem, {
      [styles.selected]: this.props.isSelected
    });

    return (
      <div className={itemClasses} onClick={this.onClick} title={this.props.item.itemName}>
        <div className={styles.autocompleteItemContents}>
          <Row>
            <Col xs={1} className={styles.itemIconCol}>
              <Icon
                appName="GeneralLayout"
                assetName="GENERAL_L_Feedback"
                className={iconStyles.smallIcon}
              />
            </Col>
            <Col xs={5}>
              <div className={styles.autocompleteItemNameContainer}>{this.props.item.itemName}</div>
            </Col>
            <Col xs={3} className={styles.feedbackCategoryCol}>
              <FeedbackCategoryBadge category={this.props.item.category} />
            </Col>
            <Col xs={3} className={styles.feedbackStateCol}>
              <FeedbackWorkflowStateBadge state={this.props.item.state} />
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

export default withRouter(FeedbackAutocompleteResult);
